import { Spinner } from 'components/Elements';
import { MainLayout } from 'components/Layout';
import { lazyImport } from 'utils/lazyImport';
import { Suspense } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { ChooseCountry, ChooseTheme, SuggestionBox } from 'features/misc';

const { Dashboard } = lazyImport(() => import('features/misc'), 'Dashboard');
const { TransactionsRoutes } = lazyImport(
  () => import('features/transactions'),
  'TransactionsRoutes'
);
const { FinanceRoutes } = lazyImport(
  () => import('features/financeManagement'),
  'FinanceRoutes'
);
const { UpdatesRoutes } = lazyImport(
  () => import('features/updates'),
  'UpdatesRoutes'
);
const { IssuesRoutes } = lazyImport(
  () => import('features/issues'),
  'IssuesRoutes'
);
const { AccountRoutes } = lazyImport(
  () => import('features/account'),
  'AccountRoutes'
);
const { KYCRoutes } = lazyImport(() => import('features/kyc'), 'KYCRoutes');
const { StatisticsRoutes } = lazyImport(() => import('features/statistics'), 'StatisticsRoutes');
const { StructureRoutes } = lazyImport(
  () => import('features/vaultLayer'),
  'StructureRoutes'
);
const { DocumentationRoutes } = lazyImport(
  () => import('features/docs'),
  'DocumentationRoutes'
);
const { UsersRoutes } = lazyImport(
  () => import('features/users'),
  'UsersRoutes'
);
const { MessagesRoutes } = lazyImport(
  () => import('features/messages'),
  'MessagesRoutes'
);
const { IntegrationsRoutes } = lazyImport(
  () => import('features/integrations'),
  'IntegrationsRoutes'
);
const { LegalDocsRoutes } = lazyImport(
  () => import('features/legalDocs'),
  'LegalDocsRoutes'
);
const { ActivityRoutes } = lazyImport(
  () => import('features/activity'),
  'ActivityRoutes'
);
const { WidgetsRoutes } = lazyImport(
  () => import('features/widgets'),
  'WidgetsRoutes'
);
const { NotificationsRoutes } = lazyImport(
  () => import('features/notifications'),
  'NotificationsRoutes'
);
const { AdministrationRoutes } = lazyImport(
  () => import('features/administration'),
  'AdministrationRoutes'
);

const App = () => {
  return (
    <MainLayout>
      <Suspense
        fallback={
          <div className="h-full w-full flex items-center justify-center">
            <Spinner size="xl" />
          </div>
        }
      >
        <Outlet />
      </Suspense>
    </MainLayout>
  );
};

export const protectedRoutes = [
  { path: '/dev/suggestion-box', element: <SuggestionBox /> },
  { path: '/onboarding/choose-country', element: <ChooseCountry /> },
  { path: '/onboarding/choose-theme', element: <ChooseTheme /> },
  { path: '/app/account/*', element: <AccountRoutes /> },
  {
    path: '/app',
    element: <App />,
    children: [
      { path: '/app/', element: <Dashboard /> },
      { path: '/app/transactions/*', element: <TransactionsRoutes /> },
      { path: '/app/finance/*', element: <FinanceRoutes /> },
      { path: '/app/analytics/*', element: <StatisticsRoutes /> },
      { path: '/app/kyc/*', element: <KYCRoutes /> },
      { path: '/app/administration/*', element: <AdministrationRoutes /> },
      { path: '/app/conversations/*', element: <MessagesRoutes /> },
      { path: '/app/notifications/*', element: <NotificationsRoutes /> },
      { path: '/app/users/*', element: <UsersRoutes /> },
      { path: '/app/integrations/*', element: <IntegrationsRoutes /> },
      { path: '/app/updates/*', element: <UpdatesRoutes /> },
      { path: '/app/issues/*', element: <IssuesRoutes /> },
      { path: '/app/activity/*', element: <ActivityRoutes /> },
      { path: '/app/widgets/*', element: <WidgetsRoutes /> },
      { path: '*', element: <Navigate to="." /> },
    ],
  },
  {
    path: '/sys',
    element: <App />,
    children: [
      // { path: '/sys/', element: <Dashboard /> },
      { path: '/sys/legal/*', element: <LegalDocsRoutes /> },
      { path: '*', element: <Navigate to="." /> },
    ],
  },
  {
    path: '/docs',
    element: <App />,
    children: [
      // { path: '/sys/', element: <Dashboard /> },
      { path: '/docs/learn/*', element: <DocumentationRoutes /> },
      { path: '*', element: <Navigate to="." /> },
    ],
  },

  {
    path: '/vault',
    element: <App />,
    children: [
      // { path: '/sys/', element: <Dashboard /> },
      { path: '/vault/*', element: <StructureRoutes /> },
      { path: '*', element: <Navigate to="." /> },
    ],
  },
];
